module.exports = __webpack_public_path__ + "img/content-wrapper-width-variants.f8a5c1b9.png";